import React from "react";
import Card from "@mui/material/Card";
import Footer from "../../../components/Footer";
import MDBox from "../../../components/MDBox";
import DashboardNavbar from "../../../components/Navbars/DashboardNavbar";
import DashboardLayout from "../../../components/LayoutContainers/DashboardLayout";
import DataTable from "../../../components/DataTable/DataTable";
import {API_URL, APP_URL, COLOR_SECONDARY} from "../../../config";
import useDoctors from "./useDoctors";
import {NavLink} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import QrIcon from "@mui/icons-material/QrCode";

const Doctors = () => {

    const {actions, filters, renderStatusChip} = useDoctors();

    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <MDBox pt={2} pb={3}>
                <MDBox mb={3}>
                    <Card>
                        <DataTable
                            endpoint={`${API_URL}/doctors`}
                            title="Doctores"
                            description="Administra los doctores afiliados."
                            sortBy="name"
                            sortDirection="asc"
                            filters={filters}
                            actions={actions}
                            colData={[
                                {
                                    name: 'id',
                                    label: 'ID',
                                    options: {
                                        display: 'excluded',
                                        filter: false
                                    }
                                },
                                {
                                    name: 'name',
                                    label: 'Nombre',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <NavLink to={`/doctores/${tableMeta.rowData[0]}`}
                                                     key={`doctor-${tableMeta.rowData[0]}`}
                                                     style={{fontWeight: 500, color: COLOR_SECONDARY, textDecoration: 'underline'}}
                                            >
                                                {value}
                                            </NavLink>
                                        )
                                    }
                                },
                                {
                                    name: 'email',
                                    label: 'Correo electrónico'
                                },
                                {
                                    name: 'phone',
                                    label: 'Teléfono'
                                },
                                {
                                    name: 'address',
                                    label: 'Dirección',
                                    options: {
                                        display: 'hidden',
                                        filter: false
                                    }
                                },
                                {
                                    name: 'specialty',
                                    label: 'Especialidad',
                                    options: {
                                        display: 'hidden',
                                        filter: false
                                    }
                                },
                                {
                                    name: 'badge',
                                    label: 'Cédula'
                                },
                                {
                                    name: 'qr_image',
                                    label: 'QR',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => {
                                            return <IconButton color="secondary" onClick={() => window.open(`${APP_URL}/storage/doctors/qr/${value}`, "_blank")}>
                                                <QrIcon />
                                            </IconButton>
                                        },
                                        filter: false
                                    }
                                },
                                {
                                    name: 'is_active',
                                    label: 'Estado',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => {
                                            return renderStatusChip(value)
                                        }
                                    }
                                }
                            ]}
                        />
                    </Card>
                </MDBox>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default Doctors;
